module.exports = __webpack_public_path__ + "img/contractor.0e21ae37.svg";